import React from "react";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../common/openapi";

import { AppliesTo } from "./common/applies-to";
import { InternalPastRuleTiming } from "./common/internal-past-rule-timing";
import { PastRulesAlert } from "./common/past-rules-alert";
import { RuleSelector } from "./common/rule-selector";
import { SilencingNote } from "./common/silencing-note";

export function InternalPastWithSelector({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	return (
		<div className="drawer-body flex flex-col gap-6">
			<PastRulesAlert />
			<RuleSelector />
			<InternalPastRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
		</div>
	);
}
